import React, { useEffect, useState } from 'react';
import { IonLoading, isPlatform, IonToast } from '@ionic/react';
import { createStructuredSelector } from 'reselect';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { compose } from 'redux';
import "../theme/globalStyle.scss";
import {
  closePermissionAlert,
  showPermissionAlert,
  clearDeepLinkURI,
  updateNetworkStatus,
  logout
} from './actions/Login/action';
import {
  updateGpsCoordinates,
  getMoreTabContent,
  showAlert,
  initializeOfflineModule,
  createOfflineJSON,
  updateOfflineContent,
  findSearchData,
  findShipmentInfo,
  storeAccessToken,
  registerUser,
  searchByReferenceId,
  clearRegisterUserStatusMessage,
  showNetworkAlert,
  devicePlatform,
  getWebNotifications,
  termsAndConditionRequest,
  setDynamicLinkParams,
  uploadDocumentConfigRequest,
  getUserPreferences
} from './actions/App/action';
import {
  getLoading,
  getDeepLinkURI,
  getUserMasterData,
  getDeviceRegistrationResult,
  getAlertTitle,
  getAlertMessage,
  getShowAlert,
  getNetworkStatus,
  getOfflineData,
  getConfigParams,
  getSearchParams,
  getRegisterUserStatusMessage,
  getNotificationData,
  getShipmentParams,
  getSearchedLoadDataByReferenceId,
  getNavUrl,
  getHomeWebContent,
  isCapacitor,
  isContentStackApiCalled,
  getWebNotificationsData,
  getSearchRefDeepLink,
  getParamsDict
} from './selectors/selector';
import searchSaga from './saga/Search/Search.saga';
import myLoadSaga from './saga/MyLoad/saga';
import carrierAssigned from './saga/CarrierAssign/saga';
import useInjectSaga from './utils/injectSaga';
import useInjectReducer from './utils/injectReducer';
import reducer from './reducers/App/reducer';
import saga from './saga/App/saga';

import { useGeolocation } from '../app/utils/useGeolocation';
import { PermissionAlert } from '../app/components/PermissionsAlert/PermissionAlert';
import {
  getShowPermissionAlert,
  getPermissionAlertMessage,
  getPermissionAlertTitle,
  makeDriverAssign
} from '../app/selectors/selector';

import {
  makeSelectRecommended,
  getApiErrorMessage,
  getMemberApiError
} from '../app/selectors/Home/selector';
import { clear, GPSWrapper, IONICWrapper, ISGUEST, isMobile, LPEFeedbackWrapper } from '../app/utils/common';
import { fetchUserDetails, hideAlert, SetContentStackApiCalled ,fetchUserDetailsNew } from '../app/actions/App/action';
import {
  driverAssignedLoadsFromPush,
  globalSearchdata,
  shipmentForStartTrip,
  shipmentForStartTripTimestamp
} from './actions/carrierAssign/action';
import { fetchShipments } from '../app/actions/carrierAssign/action';
import { Alert } from './components/Alert/Alert';
import {
  getDriverAssignedLoads,
  getCarrierAssignedLoads,
  getInTransitLoads,
  makeMyLoadCardData,
  getRecentDeliveredLoads,
  getDeliveredWithPPWKLoads,
  getCount,
  isShipmentsAvailable
} from './selectors/Myload/selector';
import { ToastMessage } from './utils/ToastMessage';
import {
  MODULES,
  ALERT_BUTTON_ROLES,
  USER_ROLES,
  DEEPLINK_ERR_INVALID,
  CONTENT_OR_CONFIG_TABLE_MAPPING,
  SHIPMENTSTATE,
  MY_LOADS_BUCKET,
} from './utils/constants';
import { GetrecentData } from './actions/Recent/action';
import { getFavoriteData } from './actions/Favorite/action';
import { makeRecent } from './selectors/RecentSearch/selector';
import { makeFavorite } from './selectors/FavouriteSearch/selector';
import favoriteReducer from './reducers/Favorite/reducer';
import recentReducer from './reducers/Recent/reducer';
import { MyLoadCard } from './actions/myload/action';
import { RegisterContainer } from './containers/RegisterContainer/RegisterContainer';
import { transferRequest, resetLoadedStatus } from './actions/manage/action';
import { clearApiResponseError, showMemberApiError } from './actions/Home/action';
import { buyLoadShipmentRequest } from './actions/BookLoad/action';
import { setEnabled } from './utils/Crashlytics';
import i18n from '../i18n';
import { networkCheck } from './utils/network/Network.util';
import { getNotificationDetails } from './utils/Notification.util';
import { getFavoriteSearchData, getRecentSearchData, getShipmentData, getOfflineDetails } from './utils/OffNetwork.util';
import { getDetailsByUser, isUserRegistered } from './utils/UserDetails.util';
import { useAuthService } from './services/Auth';
import { LogIn } from './models/home/login.model';
import { AppConfig } from './AppConfig';
import lpefeedbacksaga from './saga/LPEFeedback/saga'

import AppUpdate from './components/AppUpdate';
import { LPEFeedback } from './schemas/LPEFeedback/LPEFeedback.schema';
import { LPESource } from './utils/LPEFeedback/LPESource';
import { initializeGeoservice } from './services/GeoService';
import _ from "lodash";
import { searchByLoadId } from './components/app/Bars/Bar-header.util';
import { isAdminRole, isDispatcherRole } from './utils/roleUtil/RoleUtil';
import { getShipmentByStateCall } from './utils/auth-utils';

const key = 'App';
export const App: React.FC = (props: any) => {
  const {
    loading,
    deepLinkURI,
    driverAssignedLoads,
    carrierAssignedLoads,
    isNetworkAvailable,
    inTransitLoads,
    notificationData,
    getShipmentParams,
    memberApiError,
    setMemberApiError,
    searchedLoadDataByReferenceId,
    devicePlatform,
    isCapacitor,
    getWebNotifications,
    paramsDict,
    searchrefdeepLinkURI,
    userDetails,
  } = props;
  const { currentPosition, errorMessage } = useGeolocation();
  const { push, location, replace } = useHistory();
  const [isRegistered, setRegistered] = useState(true);
  const [hasUpdateLoads, sethasUpdateLoads] = useState(false);
  const [driverOnlySelected, setDriverOnlySelected] = useState(false);
  const dispatch = useDispatch();
  const GUEST = getGuest();
  const DRIVER = getDriver();
  const DISPATCHER = isDispatcherRole();
  const ADMIN = isAdminRole();
  const DeepLinkInvalid = getDeepLinkInvalid();
  useEffect(() => {

    let lpeSource: LPEFeedback.ILPESource = new LPESource();
    LPEFeedbackWrapper.setSource(lpeSource);

    const routePath = window.location.pathname;
    const routeScreen = routePath.split("/");
    routeCall(routePath, routeScreen);
    
  }, [window.location.pathname.toString()])

  useEffect(() => {
    _.once(initializeGeoservice)(); 
  }, []);

  useEffect(() => {
    dispatch(termsAndConditionRequest());
    dispatch(
      uploadDocumentConfigRequest([
        {
          configTable: CONTENT_OR_CONFIG_TABLE_MAPPING.Document.tableName,
          configFilter: `key~${CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key}`
        }
      ])
    );
    try {
      isMobile && dispatch(getUserPreferences())
      isMobile && getShipmentByStateCall()
      if (isPlatformCheck()) {
        const deepLink = getDeeplinkURISession();
        const params = getStorageParams();
        const paramObj = getJSONParams(params);
        if(deepLink){
          dispatch(setDynamicLinkParams({
            paramsDict: paramObj ? {
              ...paramObj
            }:null,
            deepLinkURI: deepLink
          }));
          windowRemove();
        }
      }
    }
    catch (error) { }
  }, []);

  const navigateToMyLoads = (pathName: any) => {
    if (searchLoadReferenceByLoad(searchedLoadDataByReferenceId)) {
      const shipment = searchLoadDataByReferenceCheck(searchedLoadDataByReferenceId);
      const _navData = navigationLogicForGlobalSearch(shipment, props,dispatch)
      if (_navData && _navData.redirectionURL) {
        const { redirectionURL, ...restData } = _navData;
        isMobile ? replace(redirectionURL, { ...restData }) : replace(redirectionURL, { ...restData })
      }
    }
  }
  useEffect(() => {
    const searchedLoadId = getSearchLoadId(paramsDict);
    const loadId = getLoadId(searchedLoadDataByReferenceId);
    const shipmentId = getShipmentIdDetails(searchedLoadDataByReferenceId);
    if ((shipmentId || loadId)) {
      const pathName = getPathName(searchedLoadId, loadId, shipmentId, location);
      loadId && pushSearchResults(loadId, push, pathName);
      shipmentId && navigateToMyLoads(pathName);
    }
  }, [searchedLoadDataByReferenceId])

  const userPrincipalName: string = getUserDetailsPrincipalName(props)
  const pathname: string = location.pathname;
  useEffect(() => {
    getNotificationCall(userPrincipalName, getWebNotifications, props);
  }, [userPrincipalName, pathname]);

  useEffect(() => {
    const isCapacitor = isPlatform('capacitor');
    devicePlatform(isCapacitor);
    setEnabled(true);
    networkCheck(props);
  }, [])

  useEffect(() => {
    getDetailsByUser(props, isRegistered);
    const { registerClicked } = props.getRegisterUserStatus;
    registeredClickedCall(registerClicked, setRegistered, props, push, isCapacitor);
  }, [userDetails, props.getRegisterUserStatus]);
 
  useEffect(() => {
    getUpdateCoordinates(currentPosition, props);
  }, [currentPosition]);

  useEffect(() => {
    deeplinkURLCheck(deepLinkURI, sethasUpdateLoads);
  }, [driverAssignedLoads, carrierAssignedLoads, inTransitLoads]);

  useEffect(() => {
    getNotificationDetails(props, sethasUpdateLoads, hasUpdateLoads, push);
  }, [
    deepLinkURI,
    notificationData,
    driverAssignedLoads,
    carrierAssignedLoads,
    isNetworkAvailable,
    inTransitLoads
  ]);

  useEffect(() => {
    if (!errorMessage.errorMsg) return;
    props.showPermissionAlert({
      isShowPermissionAlert: true,
      permissionAlertMessage: errorMessage.errorMsg,
      permissionAlertTitle: errorMessage.title
    });
  }, [errorMessage]);

  useEffect(() => {
    getOfflineDetails(props)
  }, [isNetworkAvailable, props.getOfflineData]);

  useEffect(() => {
    if (isRegistered) getRecentSearchData(props);
  }, [props.getSearchParams && props.getSearchParams.RecentSearch, isRegistered]);

  useEffect(() => {
    if (isRegistered) getFavoriteSearchData(props);
  }, [props.getSearchParams && props.getSearchParams.FavouriteSearch, isRegistered]);

  useEffect(() => {
    if (isRegistered) getShipmentData(props);
  }, [getShipmentParams && getShipmentParams.shipment, isRegistered]);

  const authService = useAuthService();
  const azureLogout = async () => {
    setMemberApiError();
    if (isCapacitor) {
      GPSWrapper.details.stopGPS();
    }
    await clear();
    await authService.logout();
    const _clear = new LogIn();
    _clear.clearToken();
  };
  const buttons = [
    {
      text: i18n.t('Ok_TEXT'),
      role: ALERT_BUTTON_ROLES.ok,
      cssClass: 'firstBtn',
      handler: () => { props.hideAlert(); }
    }
  ]


  useEffect(()=>{
    if(getRolewiseManageCapacityRedirectionCheck(searchrefdeepLinkURI,DISPATCHER,ADMIN)){
      return manageCapacityRedirection(paramsDict,DISPATCHER,ADMIN, replace, push)
    }
    if(!paramsDict && checkMyloadBucketDeeplink(searchrefdeepLinkURI,GUEST)){
      return MyLoadBucketRedirection(DISPATCHER, replace, push)
    }
    if(getDriverSearchCheck(DRIVER, searchrefdeepLinkURI)){
      const path = getSearchPath(GUEST, searchrefdeepLinkURI);
      getSearchDeepLinkURl(pathname, searchrefdeepLinkURI, GUEST, replace, path, push); 
    }
    else if(guestSearchRefDeepLink(GUEST, searchrefdeepLinkURI)){
      driverAssignedPath(DRIVER, searchrefdeepLinkURI, pathname, replace, push); 
    }
    if (getDriverSearchRefDeepLinkURI(DRIVER, searchrefdeepLinkURI)){ 
      deepLinkInvalidToastMessage(DeepLinkInvalid); 
      dispatch(setDynamicLinkParams({paramsDict:null,deepLinkURI:null})); 
      driverAssignAndMyloadPath(push, pathname, replace); 
    }
    if (guestSearchDeepLinkURI(GUEST, searchrefdeepLinkURI)){ 
      deepLinkInvalidToastMessage(DeepLinkInvalid); 
      dispatch(setDynamicLinkParams({paramsDict:null,deepLinkURI:null})); 
      (pathname && pathname!== "/app/search") && replace("/app/search"); 
    }
    if(getDeepLinkPreference(GUEST, searchrefdeepLinkURI)){
      const path = getSearchDeepLinkURI(searchrefdeepLinkURI);
      deepLinkSearchURI(pathname, searchrefdeepLinkURI, replace, path, push); 
      dispatch(setDynamicLinkParams({paramsDict:null,deepLinkURI:null}));
    }
    },[searchrefdeepLinkURI])

    useEffect(()=>{
      const carrierId = getCarrierId(props);
      if(deeplinkDriverRegistered(DRIVER, carrierId, props, isRegistered, searchrefdeepLinkURI)){
        searchByReferenceLoad(paramsDict, props);
      }
      else if(searchRefDeepLink(GUEST, carrierId, isRegistered, searchrefdeepLinkURI)){
        searchByReferenceByShipment(paramsDict, props);
      }
      },[userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId,searchrefdeepLinkURI])

  return (
    <>
      <AppUpdate/>
      <IonLoading
        isOpen={loading}
        spinner={null}
        message={`<img src= 'assets/images/Schneider_Spinner-transparent.gif' className='loader-image' />`}
        show-backdrop={false}
        cssClass="loader-message"
      />
      <Alert
        title={i18n.t(props.alertTitle)}
        isOpen={props.isShowAlert}
        message={i18n.t(props.alertMessage)}
        buttons={buttons}
        dismiss={() => {
          props.hideAlert();
        }}
        mode="md"
      />
      {props.isShowPermissionAlert ? (
        <PermissionAlert
          title={props.permissionAlertTitle}
          isOpen={props.isShowPermissionAlert}
          message={props.permissionAlertMessage}
          close={props.closePermissionAlert}
        />
      ) : null}
      <IonToast
        isOpen={!!props.apiError}
        message={i18n.t(props.apiError)}
        duration={5000}
        color="dark"
        onDidDismiss={() => {
          props.clearApiResponseError();
        }}
      />
      <Alert
        title={i18n.t('Alert!')}
        isOpen={memberApiError}
        message={i18n.t('MEMBER_API_ERROR_MESSAGE')}
        cssClass="register-alert"
        buttons={[
          {
            text: i18n.t('Ok_TEXT'),
            role: ALERT_BUTTON_ROLES.ok,
            handler: async () => {
              azureLogout();
            }
          }
        ]}
        mode="ios"
      />
      {isRegistered ? (
        <AppConfig {...props} />
      ) : (
        <RegisterContainer setUserState={(value: boolean) => setRegistered(value)} setDriverOnlySelected={setDriverOnlySelected} driverOnlySelected={driverOnlySelected} {...props} />
      )}
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  isShowPermissionAlert: getShowPermissionAlert(),
  permissionAlertMessage: getPermissionAlertMessage(),
  permissionAlertTitle: getPermissionAlertTitle(),
  hiddenbarBottom: makeDriverAssign(),
  deepLinkURI: getDeepLinkURI(),
  data: makeSelectRecommended(),
  userDetails: getUserMasterData(),
  deviceResult: getDeviceRegistrationResult(),
  alertTitle: getAlertTitle(),
  alertMessage: getAlertMessage(),
  isShowAlert: getShowAlert(),
  driverAssignedLoads: getDriverAssignedLoads(),
  carrierAssignedLoads: getCarrierAssignedLoads(),
  isNetworkAvailable: getNetworkStatus(),
  getOfflineData: getOfflineData(),
  getConfigParams: getConfigParams(),
  getSearchParams: getSearchParams(),
  getShipmentParams: getShipmentParams(),
  notificationData: getNotificationData(),
  inTransitLoads: getInTransitLoads(),
  apiError: getApiErrorMessage(),
  recentLoadsData: makeRecent(),
  favoriteLoadsData: makeFavorite(),
  getRegisterUserStatus: getRegisterUserStatusMessage(),
  memberApiError: getMemberApiError(),
  searchedLoadDataByReferenceId: getSearchedLoadDataByReferenceId(),
  contentStackData: getHomeWebContent(),
  navigation: getNavUrl(),
  isCapacitor: isCapacitor(),
  isContentStackApiCalled: isContentStackApiCalled(),
  getWebNotificationsData: getWebNotificationsData(),
  paramsDict : getParamsDict(),
  searchrefdeepLinkURI : getSearchRefDeepLink(),
  myLoadsCardData : makeMyLoadCardData(),
  deliveredLoads : getRecentDeliveredLoads(),
  deliveredWithPPWKLoads : getDeliveredWithPPWKLoads(),
  myLoadCount:getCount(),
  isShipmentsAvailable : isShipmentsAvailable()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  updateGpsCoordinates: (data: any) => dispatch(updateGpsCoordinates(data)),
  closePermissionAlert: () => dispatch(closePermissionAlert()),
  showPermissionAlert: (data: any) => dispatch(showPermissionAlert(data)),
  clearDeepLinkURI: () => dispatch(clearDeepLinkURI()),
  getUserDetails: (token: string, data: any) =>
    dispatch(fetchUserDetails({ token, body: data })),
    getUserDetailsNew: (token: string, data: any) =>    
      dispatch(fetchUserDetailsNew({ token, body: data })),
  initializeModule: (lastVer: string) =>
    dispatch(initializeOfflineModule(lastVer)),
  createOfflineJSON: (jsonObj: any) => dispatch(createOfflineJSON(jsonObj)),
  updateOfflineContent: (updatedContent: any) =>
    dispatch(updateOfflineContent(updatedContent)),
  findSearchData: (carrierId: string, searchParams: any) =>
    dispatch(findSearchData({ carrierId, searchParams })),
  findShipmentInfo: (carrierId: string, searchParams: any) =>
    dispatch(findShipmentInfo({ carrierId, searchParams })),
  fetchDriverShipments: (query: any, isHideLoader = true, callback: any) =>
    dispatch(driverAssignedLoadsFromPush({ query, isHideLoader, callback })),
  fetchShipments: (details: any) => dispatch(fetchShipments(details, false)),
  updateNetworkStatus: (data: any) => dispatch(updateNetworkStatus(data)),
  hideAlert: () => dispatch(hideAlert()),
  getMoreTabContent: (data: any) => dispatch(getMoreTabContent(data)),
  showAlert: (data: any) => dispatch(showAlert(data)),
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  myLoadData: () => dispatch(MyLoadCard()),
  recentLoads: (recentSearch: any, isHideLoader: boolean) =>
    dispatch(GetrecentData(recentSearch, isHideLoader)),
  favoriteLoads: (favoriteSearch: any, isHideLoader: boolean) =>
    dispatch(getFavoriteData(favoriteSearch, isHideLoader)),
  storeAccessToken: (token: any) => dispatch(storeAccessToken(token)),
  registerUser: (token: string, data: any) => {
    dispatch(registerUser({ token, body: data }));
  },
  shipmentForStartTrip: (shipment: any) => {
    dispatch(shipmentForStartTrip(shipment));
    dispatch(shipmentForStartTripTimestamp(new Date().getTime().toString()));
  },
  transferRequest: (payload: any) => dispatch(transferRequest(payload)),
  resetUsersLoaded: () => dispatch(resetLoadedStatus()),
  clearApiResponseError: () => {
    dispatch(clearApiResponseError());
  },
  setMemberApiError: () => dispatch(showMemberApiError(false)),
  buyLoadShipmentRequest: (payload: any, renderCallback: Function) =>
    dispatch(buyLoadShipmentRequest(payload, renderCallback)),

  searchByReferenceId: (payload: any, isHideLoader: boolean, callback?: any) => {
    dispatch(searchByReferenceId(payload, isHideLoader,callback))
  },
  getWebNotifications: (payload: any) => dispatch(getWebNotifications(payload)),
  clearRegisterUserStatus: () => dispatch(clearRegisterUserStatusMessage()),
  devicePlatform: (payload: boolean) => dispatch(devicePlatform(payload)),
  setContentStackApiCalled: (payload: boolean) => dispatch(SetContentStackApiCalled(payload)),
  logout: () => dispatch(logout()),
  fetchShipmentsDeepLink: (details: any,isHideLoader = false,callBack:any) => dispatch(fetchShipments(details, false, callBack)),
  searchByReferenceIdDeepLink: (payload: any, isHideLoader: boolean, callBack:any) => {
    dispatch(searchByReferenceId(payload, isHideLoader, callBack))
  },
  setDynamicLinkParams: (payload:any) => dispatch(setDynamicLinkParams(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = useInjectReducer({ key, reducer });
const favReducer = useInjectReducer({
  key: 'Favorite',
  reducer: favoriteReducer
});
const recentInjectReducer = useInjectReducer({
  key: 'recent',
  reducer: recentReducer
});

const withSaga = useInjectSaga({ key, saga });
const searchInjectSaga = useInjectSaga({ key: 'search', saga: searchSaga });
const myLoadInjectSaga = useInjectSaga({ key: 'myload', saga: myLoadSaga });

const carrierAssignedSaga = useInjectSaga({
  key: 'carrierAssigned',
  saga: carrierAssigned
});

const lpeFeedbackSaga = useInjectSaga({ key: "feedback", saga: lpefeedbacksaga });

export default compose(
  withSaga,
  searchInjectSaga,
  carrierAssignedSaga,
  myLoadInjectSaga,
  withReducer,
  favReducer,
  recentInjectReducer,
  lpeFeedbackSaga,
  withConnect
)(React.memo(App));
const getGuest=()=> {
  return IONICWrapper && IONICWrapper.details.auth && IONICWrapper.details.auth.user && IONICWrapper.details.auth.user.roles && IONICWrapper.details.auth.user.roles.length === 1 && IONICWrapper.details.auth.user.roles[0] === USER_ROLES.carrierGuest || false;
}

const getDriver=()=> {
  return IONICWrapper && IONICWrapper.details.auth && IONICWrapper.details.auth.user && IONICWrapper.details.auth.user.roles && IONICWrapper.details.auth.user.roles.length === 1 && IONICWrapper.details.auth.user.roles[0] === USER_ROLES.carrierDriver || false;
}

const getDeepLinkInvalid=()=> {
  return IONICWrapper.details.keys && IONICWrapper.details.keys.configuration && IONICWrapper.details.keys.configuration.deepLinkInvalid || DEEPLINK_ERR_INVALID;
}

const routeCall = (routePath: string, routeScreen: string[])=>{
  if ((isPlatform('desktop') || isPlatform('mobileweb')) && routePath && routePath.indexOf("/app/stof") <= 0) {
    window.localStorage.setItem("REFRESH_URL", routeScreen[3] + (routePath.includes("ManageUser") ? "/" + routeScreen[4] : ''));
  }
}
const getSearchLoadId = (paramsDict: any) => {
  return (paramsDict && (paramsDict.shipmentId || paramsDict.loadId)) || "";
}

const getLoadId=(searchedLoadDataByReferenceId: any) =>{
  return searchedLoadDataByReferenceId &&
    searchedLoadDataByReferenceId.data &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2 &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.loadPostings &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.loadPostings[0] &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.loadPostings[0].loadId || null;
}

const getShipmentIdDetails=(searchedLoadDataByReferenceId: any)=>{
  return searchedLoadDataByReferenceId &&
    searchedLoadDataByReferenceId.data &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2 &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.shipments &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.shipments[0] &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.shipments[0].shipmentId || null;
}

const getPathName = (searchedLoadId: string, loadId: string, shipmentId: string, location: any) => {
  return (searchedLoadId !== loadId && searchedLoadId !== shipmentId) ? location.pathname : null;
}

const pushSearchResults = (loadId: any, push: any, pathName: any) => {
  (isMobile) ? push("/app/search/results" + "/" + loadId, { searchById: pathName }) : push('/app/search', { searchById: true, showResults: true,isGlobalSearch : true });
}

const getUserDetailsPrincipalName=(props: any): string=> {
  return props.userDetails && props.userDetails.memberDetailsResponse &&
  props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn;
}

const getNotificationCall=(userPrincipalName: string, getWebNotifications: any, props: any) =>{
  if (userPrincipalName && !isMobile) {
    getWebNotifications(props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn);
  }
}

const registeredClickedCall=(registerClicked: any, setRegistered: React.Dispatch<React.SetStateAction<boolean>>, props: any, push:any, isCapacitor: any)=> {
  if (registerClicked) {
    setRegistered(false);
  } else {
    isUserRegistered(props, setRegistered, push, isCapacitor);
  }
}

const getUpdateCoordinates = (currentPosition: undefined, props: any) =>{
  if (currentPosition)
    props.updateGpsCoordinates(currentPosition);
}

const deeplinkURLCheck=(deepLinkURI: any, sethasUpdateLoads: React.Dispatch<React.SetStateAction<boolean>>)=> {
  if (deepLinkURI !== '')
    sethasUpdateLoads(true);
}

const getSearchPath=(GUEST: boolean, searchrefdeepLinkURI: string) =>{
  return (GUEST && (isPlatform("desktop") || isPlatform("mobileweb"))) ? "/app/search" : searchrefdeepLinkURI;
}

const getRolewiseManageCapacityRedirectionCheck = (_searchrefdeepLinkURI: string, _dispatcher: boolean, _admin: boolean) => {
  if (_searchrefdeepLinkURI && _searchrefdeepLinkURI.includes("/app/manage-capacity")) {
    return !(_dispatcher || _admin) ? deepLinkInvalidToastMessage(getDeepLinkInvalid()) : true;
  }
  return;
}
const manageCapacityRedirection=(_paramsDict:any,_dispatcher:boolean,_admin:boolean,replace:any,push:any)=>{
  const path = ((isPlatform("desktop") || isPlatform("mobileweb"))) ? "/app/manage-capacity" : "/app/manage/ManageMyCapacity";
  if ((_admin || _dispatcher) && path) { (isMobile) ? replace({ pathname: path, state:{..._paramsDict}}) : push({pathname: path, state:{..._paramsDict}}); }
}
const checkMyloadBucketDeeplink = (_searchrefdeepLinkURI: string,_guest:boolean) => {
  if (_searchrefdeepLinkURI && _searchrefdeepLinkURI.includes("/app/MyLoad")) {
    return _guest ? deepLinkInvalidToastMessage(getDeepLinkInvalid()) : true;
  }
  return;
}
const MyLoadBucketRedirection = (_dispatcher: boolean, replace: any, push: any) => {
  const path = !(isPlatform("desktop") || isPlatform("mobileweb")) ? "/app/MyLoad" :
    (_dispatcher ? "/app/MyLoad/CarrierAssigned" : "/app/MyLoad/driverAssigned");
  (isMobile) ? replace({ pathname: path, state:{isDynamicRouting : true}}) : push(path)
}
const getDriverSearchCheck=(DRIVER: boolean, searchrefdeepLinkURI: string)=>{
  return (!DRIVER) && (searchrefdeepLinkURI && searchrefdeepLinkURI.includes("/app/search"));
}

const getSearchDeepLinkURl = (pathname: string, searchrefdeepLinkURI: string, GUEST: boolean, replace:any, path: any, push:any) =>{
  if (pathname && pathname !== searchrefdeepLinkURI) { (GUEST && isMobile) ? replace(path) : push(path); }
}

const driverAssignedPath = (DRIVER: boolean, searchrefdeepLinkURI: string, pathname: string, replace:any, push:any) => {
  const path = (DRIVER && (isPlatform("desktop") || isPlatform("mobileweb"))) ? "/app/MyLoad/driverAssigned" : searchrefdeepLinkURI;
  if(!pathname?.includes("notification")){
    if (pathname && pathname !== searchrefdeepLinkURI) { (DRIVER && isMobile) ? replace(path) : push(path); }
  }
}

const guestSearchRefDeepLink=(GUEST: boolean, searchrefdeepLinkURI: string) =>{
  return (!GUEST) && (searchrefdeepLinkURI && searchrefdeepLinkURI.includes("/app/MyLoad"));
}

const getDriverSearchRefDeepLinkURI=(DRIVER: boolean, searchrefdeepLinkURI: string) =>{
  return (DRIVER) && (searchrefdeepLinkURI && searchrefdeepLinkURI.includes("/app/search"));
}

const deepLinkInvalidToastMessage=(DeepLinkInvalid: any) =>{
  (isMobile) ? ToastMessage.show(DeepLinkInvalid) : ToastMessage.showWeb(DeepLinkInvalid);
}

const driverAssignAndMyloadPath = (push:any, pathname: string, replace:any) =>{
  (isPlatform("desktop") || isPlatform("mobileweb")) ? push("/app/MyLoad/driverAssigned") : (pathname && pathname !== "/app/MyLoad") && replace("/app/MyLoad");
}

const getSearchDeepLinkURI=(searchrefdeepLinkURI: string) =>{
  return (isPlatform("desktop") || isPlatform("mobileweb")) ? searchrefdeepLinkURI : "/app/manage/Preferences";
}

const deepLinkSearchURI=(pathname: string, searchrefdeepLinkURI: string, replace:any, path: any, push:any) =>{
  if (pathname && pathname !== searchrefdeepLinkURI) { (isMobile) ? replace(path) : push(path); }
}

const getCarrierId=(props: any)=> {
  return props && props.userDetails && props.userDetails.memberDetailsResponse &&
  props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId||null;
}


const getDeepLinkPreference=(GUEST: boolean, searchrefdeepLinkURI: string) =>{
  return (!GUEST) && (searchrefdeepLinkURI && searchrefdeepLinkURI.includes("/app/preferences"));
}
const guestSearchDeepLinkURI=(GUEST: boolean, searchrefdeepLinkURI: string) =>{
  return GUEST && (searchrefdeepLinkURI && searchrefdeepLinkURI.includes("/app/MyLoad"));
}

const deeplinkDriverRegistered = (DRIVER: boolean, carrierId: any, props: any, isRegistered: boolean, searchrefdeepLinkURI: any)=> {
  return (!DRIVER && (carrierId || (ISGUEST(props)))) && (isRegistered && searchrefdeepLinkURI && searchrefdeepLinkURI.includes("app/search"));
}

const searchByReferenceLoad=(paramsDict: any, props: any)=> {
  (paramsDict && paramsDict.loadId) && searchByLoadId(props.userDetails, paramsDict.loadId, props.searchByReferenceIdDeepLink, props.fetchShipmentsDeepLink, 1, null);
}

const searchRefDeepLink = (GUEST: boolean, carrierId: any, isRegistered: boolean, searchrefdeepLinkURI: any)=> {
  return (!GUEST && carrierId) && (isRegistered && searchrefdeepLinkURI && searchrefdeepLinkURI.includes("app/MyLoad"));
}

const searchByReferenceByShipment = (paramsDict: any, props: any)=>{
  (paramsDict && paramsDict.shipmentId) && searchByLoadId(props.userDetails, paramsDict.shipmentId, props.searchByReferenceIdDeepLink, props.fetchShipmentsDeepLink, 1, null);
}

const isPlatformCheck = ()=> {
  return (isPlatform('desktop') || isPlatform('mobileweb'));
}

const windowRemove=()=> {
  window && window.sessionStorage.removeItem("params");
  window && window.sessionStorage.removeItem("deepLinkURI");
}

const getJSONParams =(params: string | null) =>{
  return params ? JSON.parse(params) : null;
}

const getStorageParams =()=> {
  return window && window.sessionStorage.getItem("params");
}

const getDeeplinkURISession =()=> {
  return window && window.sessionStorage.getItem("deepLinkURI");
}

const searchLoadReferenceByLoad = (searchedLoadDataByReferenceId: any)=> {
  return searchedLoadDataByReferenceId && searchedLoadDataByReferenceId.data && searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.shipments;
}

const navigationLogicForGlobalSearch = (shipment: any, props: any,_dispatch?:any) => {
  if (!shipment) return null;
  if (!shipment?.shipmentState){
    isMobile
        ? ToastMessage.show(`No results found for ${shipment?.shipmentId}`)
        : ToastMessage.showWeb(`No results found for ${shipment?.shipmentId}`);
    return null;
  } 
  let temp: any;
  if (shipment?.shipmentState === SHIPMENTSTATE.TENDERED 
    ) {
    temp = {
      redirectionURL: `/app/${isMobile ? "MyLoad" : "myLoad"}/CarrierTendered`, shipments: [{ ...shipment }],
      module: isMobile ? MODULES.CARRIER_TENDERED_MODULE : props.module,
      shipmentId: shipment.shipmentId,
      callExistingAPI: false,
      showReferences: false,
      isGlobalSearch: true,
    }
    _dispatch(globalSearchdata([{ ...shipment }], MY_LOADS_BUCKET.CARRIER_TENDERED))
  }
  else if ((shipment?.shipmentState === SHIPMENTSTATE.CARRIER_ASSIGNMENT
    || shipment?.shipmentState === SHIPMENTSTATE.PENDING_CARRIER_ASSIGNMENT
    || shipment?.shipmentState === SHIPMENTSTATE.PENDING_DRIVER_UNASSIGNMENT)) {
    temp = {
    redirectionURL: `/app/${isMobile ? "MyLoad" : "myLoad"}/CarrierAssigned`, shipments: [{ ...shipment }],
    module: isMobile ? MODULES.CARRIER_ASSIGNED_MODULE : props.module,
    shipmentId: shipment.shipmentId,
    callExistingAPI: false,
    showReferences: false,
    isGlobalSearch: true,
  }
  _dispatch(globalSearchdata([{ ...shipment }], MY_LOADS_BUCKET.CARRIER_ASSIGNED))
}
  else if ((shipment?.shipmentState === SHIPMENTSTATE.PENDING_DRIVER_ASSIGNMENT
    || shipment?.shipmentState === SHIPMENTSTATE.DRIVER_ASSIGNMENT)) {
    temp = {
      redirectionURL: `/app/${isMobile ? "MyLoad" : "myLoad"}/DriverAssigned`, shipments: [{ ...shipment }],
      module: isMobile ? MODULES.DRIVER_ASSIGNED_MODULE : props.module,
      shipmentId: shipment.shipmentId,
      callExistingAPI: false,
      showReferences: true,
      isGlobalSearch: true,
    }
    _dispatch(globalSearchdata([{ ...shipment }], MY_LOADS_BUCKET.DRIVER_ASSIGNED))
  }
  else if ((shipment?.shipmentState === SHIPMENTSTATE.IN_TRANSIT)) {
    temp = {
      redirectionURL: `/app/${isMobile ? "MyLoad" : "myLoad"}/InTransit`, shipments: [{ ...shipment }],
      module: isMobile ? MODULES.INTRANSIT_MODULE : props.module,
      shipmentId: shipment.shipmentId,
      callExistingAPI: false,
      showReferences: true,
      isGlobalSearch: true,
    }
    _dispatch(globalSearchdata([{ ...shipment }], MY_LOADS_BUCKET.INTRANSIT))
  }
  else if ((shipment?.shipmentState === SHIPMENTSTATE.DELIVERED_NEEDS_PPWK)) {
    temp = {
      redirectionURL: `/app/${isMobile ? "MyLoad" : "myLoad"}/DeliveredNeedsPPWK`, shipments: [{ ...shipment }],
      module: isMobile ? MODULES.RECENTLY_DELIVERED_MODULE : props.module,
      shipmentId: shipment.shipmentId,
      callExistingAPI: false,
      showReferences: true,
      isGlobalSearch: true,
    }
    _dispatch(globalSearchdata([{ ...shipment }], MY_LOADS_BUCKET.DELIVEREDNEEDSPPWK))
  }
  else if ((shipment?.shipmentState === SHIPMENTSTATE.DELIVERED_WITH_PPWK)) {
    temp = {
      redirectionURL: `/app/${isMobile ? "MyLoad" : "myLoad"}/DeliveredWithPPWK`, shipments: [{ ...shipment }],
      module: isMobile ? MODULES.DELIVERED_WITH_PPWK_MODULE : props.module,
      shipmentId: shipment.shipmentId,
      callExistingAPI: false,
      showReferences: true,
      isGlobalSearch: true,
    }
    _dispatch(globalSearchdata([{ ...shipment }], MY_LOADS_BUCKET.DELIVEREDWITHPPWK))
  }
  return temp;
}
const searchLoadDataByReferenceCheck=(searchedLoadDataByReferenceId: any)=> {
  return searchedLoadDataByReferenceId &&
    searchedLoadDataByReferenceId.data &&
    searchedLoadDataByReferenceId.data.searchLoadByReferenceV2.shipments[0];
}